"use client";

import { useEffect, useState, useTransition } from "react";
import type { CartAttributesInput } from "./actions";
import { addCartAttributes } from "./actions";

export function CartAttributes() {
  // Used for controlling the loading state
  const [isPending, startTransition] = useTransition();
  // Updating error message
  const [error, setError] = useState<string | null>(null);
  // Set the default values
  const [formState, setFormState] = useState<CartAttributesInput>({
    "Delivery Type": "commercial",
    "Lift Gate Required": "yes",
  });

  // Initial call on mount to save default values
  useEffect(() => {
    startTransition(async () => {
      const result = await addCartAttributes(formState);
      if (result.error) {
        setError(result.error);
      }
    });
  }, []);

  //   Handle the updating of the attribute inputs
  const handleChange = (key: keyof CartAttributesInput, value: string) => {
    // Update the state
    const updated = { ...formState, [key]: value };
    setFormState(updated);

    // Add cart attributes
    startTransition(async () => {
      const result = await addCartAttributes(updated);

      //   Set the error message
      if (result.error) {
        setError(result.error);
      } else {
        setError(null);
      }
    });
  };

  return (
    <div className="space-y-4 py-4">
      <div className={isPending ? "pointer-events-none opacity-50 transition-opacity" : ""}>
        <label
          htmlFor="delivery-type"
          className="mb-1 block text-base font-normal text-black dark:text-white"
        >
          Delivery Type
        </label>
        <select
          id="delivery-type"
          className="w-full rounded border p-2"
          value={formState["Delivery Type"]}
          onChange={(e) => handleChange("Delivery Type", e.target.value)}
        >
          <option value="commercial">Commercial</option>
          <option value="residential">Residential</option>
        </select>
      </div>

      <div className={isPending ? "pointer-events-none opacity-50 transition-opacity" : ""}>
        <label
          htmlFor="lift-gate-required"
          className="mb-1 block text-base font-normal text-black dark:text-white"
        >
          Lift Gate Required?
        </label>
        <select
          id="lift-gate-required"
          className="w-full rounded border p-2"
          value={formState["Lift Gate Required"]}
          onChange={(e) => handleChange("Lift Gate Required", e.target.value)}
        >
          <option value="yes">Yes</option>
          <option value="no">No</option>
        </select>
      </div>

      {/* {isPending && <p className="text-sm text-gray-500">Saving...</p>} */}
      {error && <p className="text-sm text-red-500">Error: {error}</p>}
    </div>
  );
}
